import S from 'common/service/sanctuary';
import React from 'react';
import { compose } from 'ramda';
import { connect } from 'react-redux';
import { injectIntl, intlShape, FormattedMessage, defineMessages } from 'react-intl';
import { bool, string, func , arrayOf} from 'prop-types';

import jobShape from '@sma/components/job/shape';
import Main from 'common/mdc/layout';
import QuickSearch from 'common/components/search';
import JobPrimary from '@sma/components/job/primary';
import JobSecondary from '@sma/components/job/secondary';

import {
  actions,
  selectors ,
} from '../store/job/jobs';

import {
  selectors as jobSelectors,
} from '../store/job/job';
import WithDialog from "common/mdc/dialog/withDialog";
import CreateNewJob from '../components/job/create/createNewJob';

export const messages = defineMessages({
  title: {
    id: 'title.jobs',
    defaultMessage: 'Jobs',
  },
  search: {
    id: 'serach.jobs.placeholder',
    defaultMessage: 'Search for jobs',
  },
});

const Jobs = ({
  intl,
  search,
  query,
  selectedJob,
  onClose,
  loading,
  jobs,
  showDialog,
}) => (
  <Main
    title={<FormattedMessage {...messages.title} />}
    tools={
      <QuickSearch
        placeholder={intl.formatMessage(messages.search)}
        value={query}
        onChange={search}
      />
    }
  >
    <JobPrimary />
    {S.maybeToNullable(S.map(
      job => (
        <JobSecondary job={job} onClose={onClose} loading={loading} />
      ),
      selectedJob,
    ))}
    {showDialog ? <CreateNewJob/> : null}
  </Main>

);

Jobs.propTypes = {
  search: func.isRequired,
  query: string,
  intl: intlShape.isRequired,
  loading: bool,
  onClose: func.isRequired,
  jobs: arrayOf(jobShape),
};

Jobs.defaultProps = {
  query: '',
  jobs: [{}],
  loading: false
};

export default compose(
  connect(
    state => ({
      selectedJob: selectors.getSelected(state),
      query: selectors.getQuery(state),
      loading: selectors.isLoading(state),
      jobs: S.maybeToNullable(jobSelectors.getJobMaybe(state)),
      showDialog: state.job.jobs.createJob.showDialog,
    }),
    ({
      search: evt => actions.search(evt.target.value),
      onClose: () => actions.selectJob(null),
    }),
  ),
  WithDialog(CreateNewJob, 'createNewJob'),
  injectIntl,
)(Jobs);
